class AxAutoplayCarousel extends HTMLElement {
  connectedCallback() {
    this.interval = parseInt(this.getAttribute('autoplay'), 10);
    this.carousel = this.querySelector('scroll-carousel');

    if (!this.interval || !this.carousel || this.carousel.cells.length < 2) return;

    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.onVisibilityChange = () => (document.hidden ? this.stop() : this.start());

    this.addEventListener('pointerenter', this.stop);
    this.addEventListener('pointerleave', this.start);
    this.addEventListener('focusin', this.stop);
    this.addEventListener('focusout', this.start);
    document.addEventListener('visibilitychange', this.onVisibilityChange);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  start() {
    this.stop();
    this.timer = setInterval(() => {
      if (!this.carousel.isScrollable) return;

      const last = this.carousel.cells.length - 1;
      if (this.carousel.selectedIndex >= last) {
        this.carousel.select(0);
      } else {
        this.carousel.next();
      }
    }, this.interval);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

['ax-product-slider', 'ax-autoplay-carousel'].forEach((tag) => {
  if (!customElements.get(tag)) {
    customElements.define(tag, class extends AxAutoplayCarousel {});
  }
});
